/* eslint-disable no-redeclare */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import axios from 'axios';
import { AgGridReact } from '@ag-grid-community/react';
import {AllModules} from '@ag-grid-enterprise/all-modules';
//import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';
import Select from 'react-select';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import * as Datetime from 'react-datetime';
import { getDDMMYYYY, getDDMMYYYYHHMMSS,getHyphenDDMMMYYYYHHMM , getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';

import Map from '../common/drawmap';

import redirectURL from '../redirectURL';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import MapComponent from './mapLocationComponent';
import Consignmentforceclose from '../manage/consignmentforceclose';
import $ from 'jquery';
// import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import datetimepicker from 'jquery-datetimepicker';

var moment = require('moment');
var googleAnalytics = require("../common/googleanalytics");

const decipher = salt => {
	const textToChars = text => text.split('').map(c => c.charCodeAt(0));
	const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);
	return encoded => encoded.match(/.{1,2}/g)
		.map(hex => parseInt(hex, 16))
		.map(applySaltToChar)
		.map(charCode => String.fromCharCode(charCode))
		.join('');
}
var decode = decipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");

export default class TranshipmentReportComponent extends Component{
    constructor(props) {
        super(props);
        this.state={
            modules: AllModules,
            // truckData:this.props.truckInfo,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            basicTitle:'',
            basicType:"default",
            oldTruckNo:"",
            truckNumList:"",
            loadshow:'show-n',
            truckLocation:"",
            replaced_date_time:"",
            route_details:"",
            rowData:[],
            rowSelection:'multiple',
      	    rowModelhighchartoptionsType: 'enterprise',
			  rowGroupPanelShow: 'always',
            statusBar: {
				statusPanels: [
					{
					statusPanel: "agTotalAndFilteredRowCountComponent",
					align: "left"
					},
					{
					statusPanel: "agTotalRowCountComponent",
					align: "center"
					},
					{ statusPanel: "agFilteredRowCountComponent" },
					{ statusPanel: "agSelectedRowCountComponent" },
					{ statusPanel: "agAggregationComponent" }
				]
            },
            paginationPageSize:50,
            sideBar: {
				toolPanels: [
					{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel"
					},
					{
					id: "filters",
					labelDefault: "Filters",
					labelKey: "filters",
					iconKey: "filter",
					toolPanel: "agFiltersToolPanel"
					}
				]
			},
            route_info:"",
			animateRows: true,
            consignment_details:"",
            dept_code:"",
            replacement_truck:"",
            pagetitle:"",
            showonlytransport:'show-m',
            usergridstate:[],
            screenurl:"",
            screentitle:"",
            loginplant:""
        };
        this.cipher = this.cipher.bind(this);
    }
    cipher = (salt) => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);
        try{
            return text => text.split('')
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join('');
        }
        // eslint-disable-next-line no-unreachable
        catch(e){}

    }
    logPageView = () => {
        try {
            if (googleAnalytics.page.enableGA) {
                googleAnalytics.logPageView();
                let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
                let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
                let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
                this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
            } else {
                console.log("GA disabled...");
            }
        } catch(error) {
            console.error("Error occured while logging to GA, error = ", error);
        }
    }
    componentDidMount(){
        loadDateTimeScript();
        var loguser = decode(localStorage.getItem("m"));
    		// console.log("LOGUSER ", JSON.parse(loguser));
    		var loginplant = "";
    		try{
    			var luser = JSON.parse(loguser);
    			loginplant = luser.is_plant_code;
    			// console.log("logplant", loginplant)
    			this.setState({
    				loginplant:loginplant,
    				// consigner:[{"value":luser.is_plant_code,"label":luser.is_plant_name}]

    			})
    		}
    		catch(e){

    		}
        var encode = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
        $('#replacement-submit').prop("disabled",true);
        var loguser = decode(localStorage.getItem("m"));
    		// console.log("LOGUSER ", JSON.parse(loguser));
    		var loginplant = "";
    		try{
    			var luser = JSON.parse(loguser);
    			loginplant = luser.is_plant_code;
    			// console.log("logplant", loginplant)
    			this.setState({
    				loginplant:loginplant,
    				// consigner:[{"value":luser.is_plant_code,"label":luser.is_plant_name}]
    			})
    		}
    		catch(e){

    		}

        this.logPageView(); // Log page view to GA
		let eventAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
		this.setState({eventAction: eventAction});var pagetitle='';
        var dept_code = "";
        var rail_consignments = 0;
        if(this.props.match.path == "/sndtranshipmentreports")
        {
            dept_code = "SNDG"
            pagetitle = "Sales and Dispatch"

        }
        if(this.props.match.path == "/prttranshipmentreports")
        {
            dept_code = "LOG-PRT"
            pagetitle = "Spare Parts"
        }
        if(this.props.match.path == "/tnptranshipmentreports")
        {
            dept_code = "LOG-TNP"
            pagetitle = "Train and Production"
        }
        if(this.props.match.path == "/railtranshipmentreports"){
            dept_code = "SNDG";
            rail_consignments = 1;
            pagetitle = "Rail Consignments"
        }
        var reqParams = {
            dept_code : encode(dept_code),
            rail_consignments : rail_consignments
        }
        this.setState({
            pagetitle : pagetitle
        })
        // console.log(dept_code);
        redirectURL.post("/consignments/getTranshipmentReport",reqParams)
		  .then((response) => {
            //console.log(response);
            var records = response.data;
            if(records.length > 0){
                var recordsarr= []
                records.map((item) => {
                    if(item.replacement_truck == item.old_truck_no)
                    {

                    }
                    else{

                        recordsarr.push(item)
                    }
                })
                this.setState({
                    loadshow:'show-m',
                    eventAction:eventAction,
                    rowData : recordsarr,
                    dept_code:dept_code,
                    // pagetitle:pagetitle
                });
            }
            else{
                this.setState({
                    loadshow:'show-m',
                    eventAction:eventAction,
                    rowData : [],
                    dept_code:dept_code,
                    // pagetitle:pagetitle
                });
            }

		})
		.catch(function (error) {
		    console.log(error);
		});

		redirectURL.post("/consignments/usergridstates",{userId:localStorage.getItem("userid"),screenurl:window.location.pathname})
		.then( async (resp) => {
			await this.setState({
				usergridstate:resp.data
			});
			await this.restoreGridStates();
		})

    }


    // componentWillReceiveProps(newProps){
    //     if(newProps.rowData != this.state.rowData){
    //         this.setState({
    //             rowData : newProps.rowData,
    //         })
    //     }
    // }

    onGridReady = params => {
		this.gridApi = params.api;

	    //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;

	};


	onGridState = () =>{
		 //console.log(this.gridApi);

		 /*Get  Current Columns State and Store in this.colState */
		   this.colState = this.gridColumnApi.getColumnState();

		 /*Get Current RowGroup Columns State and Store in this.rowGroupState */
		   this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

		 /*Get Current Pivot Columns State and Store in this.pivotColumns,
		  * User should enable the Pivot mode.*/
		   this.pivotColumns = this.gridColumnApi.getPivotColumns();

		 /*Get Current Filter State and Store in window.filterState */
		   window.filterState = this.gridApi.getFilterModel();
		   this.gridApi.setFilterModel(window.filterState);



	}


    changeHandler = (event) => {
    	//console.log("Select", event.target.value);
    	let name = event.target.name;
        let value = event.target.value;
        this.setState({[name]:value});
    }
    onRowSelection(event){
		var containerslist=[];
		//console.log("rowselect", event)
		var rwCount = event.api.getSelectedNodes();
		//console.log("rwCount ", rwCount)
			//var containerlist=[];
			console.log("rowselect", event.data)
			var rowCount =  event.data
			//console.log("rowCount ", rowCount)

			rwCount.map((item) => {
				containerslist.push(item.data.truck_no)
			});

			this.setState({
				containerslist:containerslist
			})
			// console.log("checkedlist ", containerslist)

    }
    closeAlert = () => {
        this.setState({
            show: false
        });
    }



	onClickSaveGridState(){
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pagetitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventGridAction,
				"label": "Save Grid Layout",
			}
			googleAnalytics.logEvent(eventOptions);
		}
		window.colState = this.gridColumnApi.getColumnState();
		window.groupState = this.gridColumnApi.getColumnGroupState();
		window.sortState = this.gridApi.getSortModel();
		window.filterState = this.gridApi.getFilterModel();

		let screenpage = '';

		if(this.props.match.path == "/sndtranshipmentreports")
		{
			screenpage='snd transhipment reports';
		}
		else if(this.props.match.path == "/prttranshipmentreports")
		{
			screenpage='prt transhipment reports';
		}
		else if(this.props.match.path == "/tnptranshipmentreports")
		{
			screenpage='tnp transhipment reports';
		}
		else if(this.props.match.path == "/railtranshipmentreports")
		{
			screenpage='rail transhipment reports';
		}

		let reqparams = {
			gridcolumns:window.colState,
			gridgroup:window.groupState,
			gridcolsort:window.sortState,
			gridcolfilter:window.filterState,
			userId:localStorage.getItem("userid"),
			screenurl:window.location.pathname,
			screentitle:screenpage
		}
		//console.log("reqparams ", reqparams)
		redirectURL.post("/consignments/saveGridStates", reqparams)
		.then((response) => {
			//console.log("State response ",response.data)
			this.setState({
				show:true,
				basicTitle:"Successfully saved grid layout",
				basicType:"success",
				screenurl:window.location.pathname,
				screentitle:screenpage
			})
		})
		.catch(function(e){
			console.log("Error ", e)
		})
	}

	restoreGridStates()
	{

		if(this.state.usergridstate.length > 0)
		{
			var windowstates = this.state.usergridstate;
			this.gridColumnApi.setColumnState(windowstates[0].gridcolumns);
			this.gridColumnApi.setColumnGroupState(windowstates[0].gridgroup);
			this.gridApi.setSortModel(windowstates[0].gridcolsort);
			this.gridApi.setFilterModel(windowstates[0].gridcolfilter);

		}
	}

	resetState = () => {
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pagetitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventGridAction,
				"label": "Reset Grid Layout",
			}
			googleAnalytics.logEvent(eventOptions);
		}
		this.gridColumnApi.resetColumnState();
		this.gridColumnApi.resetColumnGroupState();
		this.gridApi.setSortModel(null);
		this.gridApi.setFilterModel(null);
		//console.log('column state reset');
		var reqparams = {
			userId:localStorage.getItem("userid"),
			screenurl:window.location.pathname,
			screentitle:this.state.screenpage
		}

		redirectURL.post("/consignments/removeUserGridState", reqparams)
		.then((response) => {
			this.setState({
				show:true,
				basicTitle:"Successfully reset default grid layout",
				basicType:"success"
			})
		})

	};

    onClickGetTransshipmnetReports = (event) => {
        event.preventDefault();
        var encode = this.cipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
        var from_date = $("#from_date_transshipment").val()
        var to_date = $("#to_date_transshipment").val()
        var dept_code = "";
        var rail_consignments = 0;
        if(this.props.match.path == "/sndtranshipmentreports")
        {
            dept_code = "SNDG"

        }
        if(this.props.match.path == "/prttranshipmentreports")
        {
            dept_code = "LOG-PRT"
        }
        if(this.props.match.path == "/tnptranshipmentreports")
        {
            dept_code = "LOG-TNP"
        }
        if(this.props.match.path == "/railtranshipmentreports"){
            dept_code = "SNDG";
            rail_consignments = 1;
        }
        var reqParams = {
            dept_code : encode(dept_code),
            rail_consignments : rail_consignments,
            from_date,
            to_date
        }

        redirectURL.post("/consignments/getTranshipmentReport",reqParams)
		  .then((response) => {
            //console.log(response);
            var records = response.data;
            if(records.length > 0){
                var recordsarr= []
                records.map((item) => {
                    if(item.replacement_truck == item.old_truck_no)
                    {

                    }
                    else{

                        recordsarr.push(item)
                    }
                })
                this.setState({
                    loadshow:'show-m',
                    rowData : recordsarr,
                    dept_code:dept_code,
                    // pagetitle:pagetitle
                });
            }
            else{
                this.setState({
                    loadshow:'show-m',
                    rowData : [],
                    dept_code:dept_code,
                    // pagetitle:pagetitle
                });
            }

		})
        
    }


    render(){
        if(this.props.match.path == "/railtranshipmentreports")
        {
            var columnwithDefs = [
                {
                    headerName: "Consignment Code",
                    field: "consignment_code",
                    width:120,
                    filter: true,
                    resizable: true,
                    headerCheckboxSelection: false,
                    //headerCheckboxSelectionFilteredOnly: true,
                    // checkboxSelection: true
                },
                {
                    headerName: "Transporter Code",
                    width:120,
                    field: "parent_transporter_code",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Transporter Name",
                    width:140,
                    field: "transporter_name",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Original Truck No",
                    width:120,
                    field: "old_truck_no",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Replacement Truck No",
                    field: "replacement_truck",
                    width:120,
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Transshipment Date",
                    field: "replacement_date",
                    width:150,
                    filter: true,
                    resizable: true,
                    valueGetter:function(params){
                        if(params.data.replacement_date == ""){
                            return "N/A";
                        }
                        else{
                            return getHyphenDDMMMYYYYHHMM(params.data.replacement_date)
                        }
                    },
                    //filter: "agDateColumnFilter",
				comparator: dateComparator,
				// filterParams: {
				// 	browserDatePicker: true,
				// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
				// 	// provide comparator function
				// 	comparator: function(filteredDate,cellValue,secondDate) {
				// 		cellValue = cellValue.replace(/\//g,"-")
				// 		if(cellValue != "" && cellValue != " "){
				// 			cellValue = cellValue.split(" ")[0].split("-");
				// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
				// 			var cellDate = new Date(cellValue);
				// 			if(filteredDate.getMonth() < 10){
				// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			else{
				// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			if(filterValue.split("-")[2].length < 2)
				// 			{
				// 				var temp = filterValue;
				// 				filterValue = temp.split("-")[0]+"-"+temp.split("-")[1]+"-0"+temp.split("-")[2];
				// 			}
				// 			var filteredDate = new Date(filterValue);
				// 			cellDate = cellDate.getTime();
				// 			filteredDate = filteredDate.getTime();
				// 			// console.log(cellDate,filteredDate);
				// 			if(cellDate === filteredDate)
				// 			{
				// 				return 0;
				// 			}
				// 			if(cellDate < filteredDate){
				// 				return -1;
				// 			}
				// 			if(cellDate > filteredDate)
				// 			{
				// 				return 1;
				// 			}
				// 		}
				// 	}
				// },
                },
                {
                    headerName: "Reason For Replacement",
                    field: "reason",
                    filter: true,
                    resizable: true,


                },
                {
                    headerName: "Modified By",
                    field: "transhipment_done_by",
                    width:120,
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Modified On",
                    width:120,
                    field: "transhipment_done_on",
                    filter: true,
                    resizable: true,
                    valueGetter:function(params){
                        if(params.data.transhipment_done_on != '' && params.data.transhipment_done_on != undefined)
                        {
                            return getHyphenDDMMMYYYYHHMM(params.data.transhipment_done_on);
                        }
                        else{
                            return "NA";
                        }
                    },
                    //filter: "agDateColumnFilter",
				comparator: dateComparator,
				// filterParams: {
				// 	browserDatePicker: true,
				// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
				// 	// provide comparator function
				// 	comparator: function(filteredDate,cellValue,secondDate) {
				// 		cellValue = cellValue.replace(/\//g,"-")
				// 		if(cellValue != "" && cellValue != " "){
				// 			cellValue = cellValue.split(" ")[0].split("-");
				// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
				// 			var cellDate = new Date(cellValue);
				// 			if(filteredDate.getMonth() < 10){
				// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			else{
				// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			if(filterValue.split("-")[2].length < 2)
				// 			{
				// 				var temp = filterValue;
				// 				filterValue = temp.split("-")[0]+"-"+temp.split("-")[1]+"-0"+temp.split("-")[2];
				// 			}
				// 			var filteredDate = new Date(filterValue);
				// 			cellDate = cellDate.getTime();
				// 			filteredDate = filteredDate.getTime();
				// 			// console.log(cellDate,filteredDate);
				// 			if(cellDate === filteredDate)
				// 			{
				// 				return 0;
				// 			}
				// 			if(cellDate < filteredDate){
				// 				return -1;
				// 			}
				// 			if(cellDate > filteredDate)
				// 			{
				// 				return 1;
				// 			}
				// 		}
				// 	}
				// },
                },

            ]
        }
        else
        {
            columnwithDefs = [
                {
                    headerName: "Original Truck No",
                    width:120,
                    field: "old_truck_no",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Replacement Truck No",
                    field: "replacement_truck",
                    width:120,
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Transporter Code",
                    width:120,
                    field: "parent_transporter_code",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Transporter Name",
                    width:140,
                    field: "transporter_name",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Invoice No",
                    field: "invoice_no",
                    width:120,
                    filter: true,
                    resizable: true,
                    headerCheckboxSelection: false,
                    //headerCheckboxSelectionFilteredOnly: true,
                    // checkboxSelection: true
                },
                {
                    headerName: "GR No",
                    field: "consignment_code",
                    width:120,
                    filter: true,
                    resizable: true,
                    headerCheckboxSelection: false,
                    //headerCheckboxSelectionFilteredOnly: true,
                    // checkboxSelection: true
                },
                {
                    headerName: "Gate Out Time",
                    colId : "gate_out_time",
                    field: "gate_out_time",
                    width:150,
                    filter: true,
                    resizable: true,
                    valueGetter:function(params){
                        if(params.data.gate_out_time == ""){
                            return "N/A";
                        }
                        else{
                            return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time)
                        }
                    },
                    //filter: "agDateColumnFilter",
				comparator: dateComparator,
				// filterParams: {
				// 	browserDatePicker: true,
				// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
				// 	// provide comparator function
				// 	comparator: function(filteredDate,cellValue,secondDate) {
				// 		cellValue = cellValue.replace(/\//g,"-")
				// 		if(cellValue != "" && cellValue != " "){
				// 			cellValue = cellValue.split(" ")[0].split("-");
				// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
				// 			var cellDate = new Date(cellValue);
				// 			if(filteredDate.getMonth() < 10){
				// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			else{
				// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			if(filterValue.split("-")[2].length < 2)
				// 			{
				// 				var temp = filterValue;
				// 				filterValue = temp.split("-")[0]+"-"+temp.split("-")[1]+"-0"+temp.split("-")[2];
				// 			}
				// 			var filteredDate = new Date(filterValue);
				// 			cellDate = cellDate.getTime();
				// 			filteredDate = filteredDate.getTime();
				// 			// console.log(cellDate,filteredDate);
				// 			if(cellDate === filteredDate)
				// 			{
				// 				return 0;
				// 			}
				// 			if(cellDate < filteredDate){
				// 				return -1;
				// 			}
				// 			if(cellDate > filteredDate)
				// 			{
				// 				return 1;
				// 			}
				// 		}
				// 	}
				// },
                },
                {
                    headerName: "Loading Plant",
                    width:120,
                    field: "consigner_code",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Consignee Name",
                    width:120,
                    field: "consignee_name",
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Consignee City",
                    width:120,
                    field: "consignee_city",
                    filter: true,
                    resizable: true,
                },
                // {
                //     headerName: "Transporter Code",
                //     width:120,
                //     field: "parent_transporter_code",
                //     filter: true,
                //     resizable: true,
                // },
                {
                    headerName: "Transshipment Date",
                    field: "replacement_date",
                    width:150,
                    filter: true,
                    resizable: true,
                    valueGetter:function(params){
                        if(params.data.replacement_date == ""){
                            return "N/A";
                        }
                        else{
                            return getHyphenDDMMMYYYYHHMM(params.data.replacement_date)
                        }
                    },
                    //filter: "agDateColumnFilter",
				comparator: dateComparator,
				// filterParams: {
				// 	browserDatePicker: true,
				// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
				// 	// provide comparator function
				// 	comparator: function(filteredDate,cellValue,secondDate) {
				// 		cellValue = cellValue.replace(/\//g,"-")
				// 		if(cellValue != "" && cellValue != " "){
				// 			cellValue = cellValue.split(" ")[0].split("-");
				// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
				// 			var cellDate = new Date(cellValue);
				// 			if(filteredDate.getMonth() < 10){
				// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			else{
				// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			if(filterValue.split("-")[2].length < 2)
				// 			{
				// 				var temp = filterValue;
				// 				filterValue = temp.split("-")[0]+"-"+temp.split("-")[1]+"-0"+temp.split("-")[2];
				// 			}
				// 			var filteredDate = new Date(filterValue);
				// 			cellDate = cellDate.getTime();
				// 			filteredDate = filteredDate.getTime();
				// 			// console.log(cellDate,filteredDate);
				// 			if(cellDate === filteredDate)
				// 			{
				// 				return 0;
				// 			}
				// 			if(cellDate < filteredDate){
				// 				return -1;
				// 			}
				// 			if(cellDate > filteredDate)
				// 			{
				// 				return 1;
				// 			}
				// 		}
				// 	}
				// },
                },
                {
                    headerName: "Transshipment Reason",
                    field: "reason",
                    filter: true,
                    resizable: true,


                },
                {
                    headerName: "Transshipment Done By",
                    field: "transhipment_done_by",
                    width:120,
                    filter: true,
                    resizable: true,
                },
                {
                    headerName: "Transshipment Done On",
                    width:120,
                    field: "transhipment_done_on",
                    filter: true,
                    resizable: true,
                    valueGetter:function(params){
                        if(params.data.transhipment_done_on != '' && params.data.transhipment_done_on != undefined)
                        {
                            return getHyphenDDMMMYYYYHHMM(params.data.transhipment_done_on);
                        }
                        else{
                            return "NA";
                        }
                  },
                  //filter: "agDateColumnFilter",
				comparator: dateComparator,
				// filterParams: {
				// 	browserDatePicker: true,
				// 	filterOptions: ['equals','greaterThan','lessThan','notEqual','inRange','greaterThanOrEqual','lessThanOrEqual'],
				// 	// provide comparator function
				// 	comparator: function(filteredDate,cellValue,secondDate) {
				// 		cellValue = cellValue.replace(/\//g,"-")
				// 		if(cellValue != "" && cellValue != " "){
				// 			cellValue = cellValue.split(" ")[0].split("-");
				// 			cellValue = cellValue[2]+"-"+getMonthNumber(cellValue[1])+"-"+cellValue[0];
				// 			var cellDate = new Date(cellValue);
				// 			if(filteredDate.getMonth() < 10){
				// 			var filterValue = filteredDate.toString().split(" ")[3]+"-0"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			else{
				// 				var filterValue = filteredDate.toString().split(" ")[3]+"-"+(filteredDate.getMonth()+1).toString()+"-"+filteredDate.getDate().toString()
				// 			}
				// 			if(filterValue.split("-")[2].length < 2)
				// 			{
				// 				var temp = filterValue;
				// 				filterValue = temp.split("-")[0]+"-"+temp.split("-")[1]+"-0"+temp.split("-")[2];
				// 			}
				// 			var filteredDate = new Date(filterValue);
				// 			cellDate = cellDate.getTime();
				// 			filteredDate = filteredDate.getTime();
				// 			// console.log(cellDate,filteredDate);
				// 			if(cellDate === filteredDate)
				// 			{
				// 				return 0;
				// 			}
				// 			if(cellDate < filteredDate){
				// 				return -1;
				// 			}
				// 			if(cellDate > filteredDate)
				// 			{
				// 				return 1;
				// 			}
				// 		}
				// 	}
				// },
                },
                {
                    headerName: "Transshipment Location",
                    field: "",
                    width:120,
                    filter: true,
                    resizable: true,
                    valueGetter : function(params){
                        if(params.data.area != undefined && params.data.state != undefined)
                        {
                            return params.data.area+"/"+params.data.state
                        }
                        else if(params.data.area != undefined && params.data.state == undefined)
                        {
                            return params.data.area+"/ NA"
                        }
                        else if(params.data.area == undefined && params.data.state != undefined)
                        {
                            return "NA /"+params.data.state
                        }
                        else
                        {
                            return "NA / NA";
                        }
                    }
                },
                {
                    headerName: "Distance From Dealer Location (KM)",
                    field: "distance_from_dealer_location",
                    width:200,
                    filter: true,
                    resizable: true,
                    valueGetter : function(params){
                        if(params.data.distance_from_dealer_location != "" && params.data.distance_from_dealer_location != undefined)
                        {
                            return Math.round(params.data.distance_from_dealer_location)
                        }
                        else
                        {
                            return "";
                        }
                    }
                },
                {
                    headerName: "Total Distance Travelled by Old Truck (KM)",
                    field: "distance_travelled_by_old_truck",
                    width:200,
                    filter: true,
                    resizable: true,
                    valueGetter : function(params){
                        if(params.data.distance_travelled_by_old_truck != undefined && params.data.distance_travelled_by_old_truck != "")
                        {
                            return Math.round(Number(params.data.distance_travelled_by_old_truck))
                        }
                        else
                        {
                            return "";
                        }
                    }
                },

            ]
        }


        return(
            <div class="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
	            {this.state.alert}
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>
                            <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>Transshipments ({this.state.pagetitle}) </span>

                            </h5>
                        </div>


                        <div className="card-body pt-15px" >
                            <div className="row">
                                <div className="col-xl-12 col-lg-12">

                                    <span className="layoutbtns pull-right">
                                        <button className="float-right custom-btn white btn-danger" onClick={this.onClickSaveGridState.bind(this)}>
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{marginRight:"10px"}} onClick={this.resetState.bind(this)}>
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                    </span>
                                </div>
                                <div className='row col-xl-12 col-lg-12'>
                                    <div class="col-xl-2 col-lg-2 form-group">
                                        <label className="col-xl-12 col-lg-12">From Date</label>
                                        <input type="text" name="date" autoComplete="off" id="from_date_transshipment" className="datetimepicker_date form-control" />
                                    </div>
                                    <div class="col-xl-2 col-lg-2 form-group">
                                        <label className="col-xl-12 col-lg-12">To Date</label>
                                        <input type="text" name="date" autoComplete="off" id="to_date_transshipment" className="datetimepicker_date form-control" />
                                    </div>
                                    <div class="col-xl-2 col-lg-2 mr-0 form-group">
                                        <label className="col-xl-12 col-lg-12">&nbsp;</label>
                                        <br />
                                        <button type="submit" onClick={this.onClickGetTransshipmnetReports} class="btn btn-success">Get Data</button>&nbsp;&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                                <div className="col-xl-12 col-lg-12">
                                {/* {this.state.rowData != null ? */}
                                    <div id="myGrid" style={{width:"100%",height:"500px"}} className="ag-theme-balham">
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={columnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        // onCellDoubleClicked={this.onShowSidebarAquireComponent.bind(this)}
                                        enableCharts={true}
                                        enableRangeSelection={true}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={true}
                                        rowSelection={this.state.rowSelection}
                                        // frameworkComponents={this.state.frameworkComponents}
                                        // detailCellRendererParams={this.state.detailCellRendererParams}
                                        //editType={this.state.editType}
                                        stopEditingWhenGridLosesFocus={true}
                                        //floatingFilter={true}
                                        enableCellChangeFlash={true}
                                        suppressCellFlash={true}
                                        // rowClassRules={this.state.rowClassRules}
                                        //onCellClicked={this.onRowClicked.bind(this)}
                                        gridOptions={{
                                            context: { componentParent: this }
                                        }}
                                        onRowSelected={this.onRowSelection.bind(this)}
                                        suppressRowClickSelection={true}
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		format:'d-m-Y H:i'
	});
	$('.datetimepicker_date').datetimepicker({
		format:'Y-m-d H:i',
		timepicker:true
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
        // console.log(date1,date2);
    var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
    date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
    var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
    date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
    // console.log(date1,date2);
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);
    // console.log(date1Number,date2Number);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
    }
  }
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    // console.log(yearNumber,monthNumber,dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName){
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
        ];
    var monthNum = months.indexOf(monthName)+1;
    if(monthNum < 10){
        monthNum = "0"+monthNum.toString();
    }
    return monthNum;
}




$(document).on("change", "#to_date_transshipment", function(e) {
    e.preventDefault();
    var bookingDate=$("#from_date_transshipment").val();
    var cargoDate=$("#to_date_transshipment").val();
	// var bookingDate = bookingDate.split("-")[2]+"-"+bookingDate.split("-")[1]+"-"+bookingDate.split("-")[0]
    // var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]
    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    // console.log(startTime,endTime);
    if(startTime > endTime)
    {
        $("#to_date_transshipment").val("");
        alert("To Date should be greater than or equal to From Date");
    }
})

$(document).on("change", "#from_date_transshipment", function(e) {
    e.preventDefault();
    var bookingDate=$("#from_date_transshipment").val();
    var cargoDate=$("#to_date_transshipment").val();
	console.log(bookingDate,cargoDate)
    // var bookingDate = bookingDate[2]+"-"+bookingDate[1]+"-"+bookingDate[0]
    // var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]
    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    if(startTime > endTime)
    {
        $("#from_date_transshipment").val("");
        alert("From Date should be less than equal to To Date");
    }
})
